/* eslint-disable @next/next/no-img-element */
import { getCta, getSubscriberStatus } from 'utils/common';
import { ASSET_PREFIX, SubscriberStatus, colors } from 'utils/constants';
// @ts-ignore
import Router from 'next/router';
import { useState } from 'react';
// @ts-ignore
import { PrizeType } from '@daymade/common-lib/dbEnums';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AspectRatioContainer from 'components/about-us/AspectRatioContainer';
import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import Chevron from 'components/Chevron';
import FaqCard from 'components/FaqCard';
import FullScreenImageGallery from 'components/gallery/FullscreenImageGallery';
import RoundedButton from 'components/RoundedButton';
import useEmblaCarousel from 'embla-carousel-react';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import { PrizeV2 as Prize } from 'types/Prize';
import { resizeImageUrl } from 'utils/image/imageResizeService';
import { parsePrizeHtmlSections } from 'utils/ParseHtml';
import { getMainCategoryForPrizeWithCategories } from 'utils/WeeklyDrawPrizeSubcategoryHelperMethods';
import Calendar from '../../svg/Calendar.svg';
import Camera from '../../svg/Camera.svg';
import Checklist from '../../svg/Checklist.svg';
import House from '../../svg/House.svg';
import Plane from '../../svg/Plane.svg';
import Present from '../../svg/Present.svg';
import Travel from '../../svg/Travel.svg';
import TrustpilotBlack45Excellent from '../../svg/TrustpilotBlack45Excellent.svg';
import TrustpilotWhiteNoNameExcellent45 from '../../svg/TrustpilotWhiteNoNameExcellent45.svg';
import Wallet from '../../svg/Wallet.svg';
import { NotAvailableBadge } from '../NotAvailableBadge';
import styles from './HeaderSectionPrize.module.css';
import { PrizeBadgeOverlay } from './PrizeBadgeOverlay';

interface IPrizeHeaderSectionProps {
  prize: Prize;
  ctaOnClick: () => void;
}
export const HeaderSection = observer(
  ({ prize, ctaOnClick }: IPrizeHeaderSectionProps) => {
    // TODO is this needed    const { boostCostPerEntry } = useEnterStore();
    const { subscriptionStatusInfo /*currentUser*/ } = useUserStore();
    const emblaCarouselInfo = useEmblaCarousel({
      loop: false,
      duration: 10,
      inViewThreshold: 0.1,
    });
    const [galleryIndex, setGalleryIndex] = useState<number | undefined>(
      undefined,
    );

    const withCtaUnderHeading = !!getCta(subscriptionStatusInfo);

    const mainCategoryOfPrize = getMainCategoryForPrizeWithCategories(
      prize.categories,
    );

    const {
      title,
      subheading,
      overviewBody,
      imageLocations,
      seoImageAltText,
      isFromPlayersSuggestion,
      mainDrawWinningCriterion,
    } = prize;

    const subscriberStatus = getSubscriberStatus(subscriptionStatusInfo);

    // Show locked prize banner if the prize is not winnable for the drawTypePlan user is subscribed to
    const showLockedPrizeBanner =
      subscriberStatus !== SubscriberStatus.NON_SUBSCRIBER &&
      mainDrawWinningCriterion &&
      Object.keys(mainDrawWinningCriterion.matchesRequired).length > 0 &&
      !(subscriberStatus in mainDrawWinningCriterion.matchesRequired);

    const getBoostJackpotPopupCTA = () => {
      switch (subscriberStatus) {
        case SubscriberStatus.PREMIUM:
        case SubscriberStatus.LITE:
          return {
            text: 'Boost my entries now',
            onClick: () => Router.push('/account/subscriptions'),
          };

        case SubscriberStatus.FREEMIUM:
          return {
            text: 'Upgrade and boost',
            onClick: () => Router.push('/account/subscriptions/upgrade'),
          };

        case SubscriberStatus.NON_SUBSCRIBER:
        default:
          return {
            text: undefined, // Use default CTA text
            onClick: undefined, // Defaults to the popup's onClose method
          };
      }
    };

    const mainImage = imageLocations.main
      ? { src: imageLocations.main, alt: seoImageAltText.main }
      : undefined;
    const secondaryImage1 = imageLocations.secondary1
      ? { src: imageLocations.secondary1, alt: seoImageAltText.secondary1 }
      : undefined;
    const secondaryImage2 = imageLocations.secondary2
      ? { src: imageLocations.secondary2, alt: seoImageAltText.secondary2 }
      : undefined;

    const otherImages = [secondaryImage1, secondaryImage2].filter(
      (x) => x != undefined,
    );
    const allImages = [
      mainImage,
      /* Temporarily only show the first image in the header carousel, and gallery is disabled, until imagery is higher resolution
      
      secondaryImage1, secondaryImage2
      */
    ].filter((x) => x != undefined);

    const parsedHtml = parsePrizeHtmlSections(prize);

    return (
      <div>
        <AboutUsModule background="grey" withNoPadding>
          <div className={styles.headerArea}>
            <div className={styles.headerImageContainer}>
              <div
                className={styles.headerImageContainerInner}
                style={{
                  /* Temporarily disable carousel until imagery is higher resolution */
                  pointerEvents: 'none',
                }}
              >
                <EmblaCarousel
                  className={styles.headerCarousel}
                  hidePips
                  stretchItemHeight
                  items={allImages.map((x, index) => (
                    <img
                      className={styles.headerImage}
                      key={index}
                      src={resizeImageUrl(x.src, { width: 1920, height: 1344 })}
                      alt={x.alt}
                    />
                  ))}
                  emblaCarouselInfo={emblaCarouselInfo}
                >
                  {/* Temporarily hide carousel until imagery is higher resolution 
                  <CarouselButtons
                    changeSelectedIndex={x => x < 0 ? emblaCarouselInfo[1]?.scrollPrev() : emblaCarouselInfo[1]?.scrollNext()}
                    dropShadow
                  />*/}
                  {showLockedPrizeBanner && (
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        left: 0,
                      }}
                    >
                      <Link href={'/account/subscriptions/upgrade'} passHref>
                        <a>
                          <div
                            style={{
                              backgroundColor: 'rgba(255, 255, 255, 0.75)',
                              padding: '24px',
                              color: colors.primaryBrandGray,
                              whiteSpace: 'break-spaces',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <img
                              src={`${ASSET_PREFIX}/images/prizes/padlock.svg`}
                              alt=""
                              style={{
                                marginRight: '1em',
                              }}
                            />

                            <p style={{ textAlign: 'left', marginTop: 0 }}>
                              This prize is available to{' '}
                              {prize.tierValue === 25000
                                ? 'Premium'
                                : 'Premium/Lite'}{' '}
                              subscribers only. <strong>Upgrade now</strong>
                              <Chevron
                                direction="right"
                                style={{
                                  marginLeft: '0.8em',
                                  verticalAlign: 'middle',
                                  display: 'inline',
                                  fontSize: '0.9em',
                                }}
                                reversed={undefined}
                                inline={undefined}
                              />
                            </p>
                          </div>
                        </a>
                      </Link>
                    </div>
                  )}
                </EmblaCarousel>
                <TrustpilotWhiteNoNameExcellent45
                  className={styles.trustPilotMobile}
                />
                {prize.tierValue && (
                  <div className={styles.prizeBadgeHolder}>
                    <PrizeBadgeOverlay value={prize.tierValue} />
                  </div>
                )}
              </div>
            </div>

            <div className={styles.headerTextContainer}>
              <div className={styles.headerTextContainerInner}>
                <h1
                  className="aboutUsTypographyHeaderXlargeOnWhite"
                  data-text={title}
                >
                  {title}
                </h1>
                {parsedHtml.attributes && (
                  <ul className={styles.attributesList}>
                    {parsedHtml.attributes.map((x, index) => (
                      <li key={index}>
                        {getIconForAttribute(x)}
                        <span className={'aboutUsTypographyBodySmall'}>
                          {x}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
                {withCtaUnderHeading && (
                  <p>
                    <RoundedButton
                      id="heroEnterNowButton"
                      onClick={ctaOnClick}
                      rebrandDm2025
                    >
                      Enter to win
                    </RoundedButton>
                  </p>
                )}

                <TrustpilotBlack45Excellent
                  className={styles.trustpilotDesktop}
                />
              </div>
            </div>
          </div>
        </AboutUsModule>

        <AboutUsModule background="white">
          <AboutUsSiteContainer>
            <div className={styles.headerContainer}>
              <div className={styles.column1}>
                <div className={styles.textContainer1}>
                  <p
                    className={
                      'aboutUsTypographyHeaderLarge ' + styles.subheading
                    }
                  >
                    {subheading}
                  </p>

                  <div
                    className={styles.overviewBody}
                    dangerouslySetInnerHTML={{
                      __html: overviewBody || '',
                    }}
                  ></div>

                  {isFromPlayersSuggestion && (
                    <p>This prize was recommended by one of our players! ❤️</p>
                  )}
                </div>
                <div className={styles.textContainer2}>
                  {withCtaUnderHeading && (
                    <div className={styles.ctaContainer}>
                      <p>
                        <strong>
                          Play now for a chance to win this along with 100s of
                          other epic prizes every week
                        </strong>
                      </p>
                      <p>
                        <RoundedButton
                          id="heroEnterNowButton"
                          onClick={ctaOnClick}
                          rebrandDm2025
                        >
                          Enter to win
                        </RoundedButton>
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.column2}>
                <div className={styles.infoContainer}>
                  {parsedHtml.sections.map((x) => (
                    <FaqCard
                      questionElement="h2"
                      rebrand2025
                      withBorder
                      withInheritedAnswerTextColor
                      icon={getSectionHeaderIcon(x.sectionHeader)}
                      question={x.sectionHeader}
                      answer={
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: x.content.reduce((acc, x) => {
                                return acc + x.content;
                              }, ''),
                            }}
                          />
                          {x.isDefaultSection
                            ? renderBundleItems(prize)
                            : undefined}
                        </>
                      }
                    />
                  ))}
                </div>

                <div className={styles.otherImagesContainer}>
                  {otherImages.map((x, index) => (
                    <span
                      /* Temporarily disable clicking to open gallery
                      
                        This element should be revert to a button when the imagery is bigger.
                        aria-label="Open image in gallery" onClick={() => setGalleryIndex(1 + index)}
                      */
                      key={index}
                      className={styles.otherImagesContainerInner}
                    >
                      <AspectRatioContainer width={1} height={1}>
                        <img
                          className={styles.otherImage}
                          src={resizeImageUrl(x.src, {
                            width: 704,
                            height: 704,
                          })}
                          alt={x.alt}
                        />
                      </AspectRatioContainer>
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {prize.subscriberDiscountContentCode && (
              <Link href="/subscriber-perks">
                <div className="w-full flex md:justify-start justify-center">
                  <div
                    className="w-full md:w-11/12"
                    style={{
                      maxWidth: '500px',
                      backgroundColor: '#E1E1E1',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: '5px',
                      padding: '2em 1.5em',
                      margin: '2em 0',
                      cursor: 'pointer',
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={`${ASSET_PREFIX}/images/discount-tag.svg`}
                      style={{
                        marginRight: '1em',
                        width: '32px',
                        flexShrink: 0,
                      }}
                    />
                    <p style={{ fontWeight: 500, fontStyle: 'italic' }}>
                      Subscribe to unlock a{' '}
                      {discountCodeTextForSubscriberDiscountContentCode(
                        prize.subscriberDiscountContentCode,
                      )}{' '}
                      <strong>and more</strong>&nbsp;→
                    </p>
                  </div>
                </div>
              </Link>
            )}

            {!prize.visible && <NotAvailableBadge />}
          </AboutUsSiteContainer>
        </AboutUsModule>

        <FullScreenImageGallery
          images={allImages}
          initialIndex={galleryIndex}
          onCloseClick={() => setGalleryIndex(undefined)}
        />
      </div>
    );
  },
);

export function renderBundleItems(
  prize:
    | Prize
    | {
        type: PrizeType;
        products?: {
          name: string;
          description: string;
          imageLocation: string | null;
        }[];
      },
) {
  return (
    [PrizeType.BUNDLE, PrizeType.OPTION, PrizeType.MULTI_OPTION].includes(
      prize.type,
    ) &&
    prize.products && (
      <ul className={styles.bundleItemsContainer}>
        {prize.products.map((bundleItem, i) => (
          <li key={i} className={styles.bundleItem}>
            {bundleItem.imageLocation && (
              <img
                className={styles.bundleImage}
                src={
                  bundleItem.imageLocation
                    ? resizeImageUrl(bundleItem.imageLocation, {
                        width: 192,
                        height: 192,
                      })
                    : 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
                }
                alt=""
              />
            )}
            <div className={styles.bundleText}>
              <strong className="aboutUsTypographyHeaderMedium">
                {bundleItem.name}
              </strong>
              {bundleItem.description}
            </div>
          </li>
        ))}
      </ul>
    )
  );
}

export function getSectionHeaderIcon(headerText: string) {
  // Replace certain characters e.g. for What's including?
  switch (headerText.toLowerCase().replace('’', "'").replace('?', '')) {
    case 'accomodation':
    case 'accommodation':
      return <House />;
    case 'activities':
    case 'accommodation & activities':
      return <Camera />;
    case 'flights':
      return <Plane />;
    case 'travel':
      return <Travel />;
    case 'extras':
      return <Present />;
    case "what's included":
      return <Checklist />;

    // Other things that were found in the database, and fallback
    case 'this prize includes:':
    case "win a trip to japan - what's included?":
    case 'in a nutshell':
    default:
      return <Present />;
  }
}

function getIconForAttribute(attributeText: string) {
  const lowerCased = attributeText.toLowerCase();
  if (lowerCased.indexOf('flights') >= 0) {
    return <Plane />;
  }
  if (lowerCased.indexOf('stay') >= 0) {
    return <House />;
  }
  if (lowerCased.indexOf('dates') >= 0) {
    return <Calendar />;
  }
  if (lowerCased.indexOf('activities') >= 0) {
    return <Camera />;
  }
  if (lowerCased.indexOf('money') >= 0 || lowerCased.indexOf('cash') >= 0) {
    return <Wallet />;
  }
  if (lowerCased.indexOf('travel') >= 0) {
    return <Travel />;
  }

  // Fallback to the present icon
  return <Present />;
}

const discountCodeTextForSubscriberDiscountContentCode = (code: string) => {
  switch (code) {
    case 'VED':
      return '15% discount with Virgin Experience Days';

    case 'AH':
      return '10% discount with Authentic House';

    case 'INDYTUTE':
      return '£10 discount with Indytute';

    case 'URBANB':
      return '10% discount with urban B';

    case 'NATURALLY-LEGIT':
      return '10% discount with Naturally Legit';

    default:
      return null;
  }
};
